import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';
import { GetOrganizationQueryKey } from '../queries/useGetOrganizationQuery';

const key = 'UPDATE_ORGANIZATION';

export const useUpdateOrganizationMutation = () => {
  const queryClient = useQueryClient();
  const { updateCurrentOrganization } = useServicesContext();

  return useMutation({
    mutationKey: [key],
    mutationFn: ({
      workLanguage,
    }: {
      workLanguage: 'NB' | 'EN' | null;
    }) => updateCurrentOrganization({ workLanguage }),

    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [GetOrganizationQueryKey],
      }),
  });
};
